/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type MinervaAskMutationVariables = Types.Exact<{
  input: Types.MinervaAskInput
}>

export type MinervaAskMutation = {
  __typename?: 'Mutation'
  minervaAsk: {
    __typename?: 'MinervaAskResponse'
    chatId: string
    requestId: string
    result:
      | { __typename: 'MinervaAnswer'; text: string }
      | {
          __typename: 'MinervaDataRequest'
          queries: string
          reason: string | null
        }
  }
}

export const MinervaAskDocument = gql`
    mutation minervaAsk($input: MinervaAskInput!) {
  minervaAsk(input: $input) {
    chatId
    requestId
    result {
      __typename
      ... on MinervaAnswer {
        text
      }
      ... on MinervaDataRequest {
        queries
        reason
      }
    }
  }
}
    `
export type MinervaAskMutationFn = Apollo.MutationFunction<
  MinervaAskMutation,
  MinervaAskMutationVariables
>

/**
 * __useMinervaAskMutation__
 *
 * To run a mutation, you first call `useMinervaAskMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMinervaAskMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [minervaAskMutation, { data, loading, error }] = useMinervaAskMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMinervaAskMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MinervaAskMutation,
    MinervaAskMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<MinervaAskMutation, MinervaAskMutationVariables>(
    MinervaAskDocument,
    options,
  )
}
export type MinervaAskMutationHookResult = ReturnType<
  typeof useMinervaAskMutation
>
export type MinervaAskMutationResult = Apollo.MutationResult<MinervaAskMutation>
export type MinervaAskMutationOptions = Apollo.BaseMutationOptions<
  MinervaAskMutation,
  MinervaAskMutationVariables
>
